import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Obtener matrices.
 */
export async function getMatrix({state, commit}, restart_page = false) {
    commit('dashboard/load', true, {root: true});

    if (restart_page) {
        commit('resetPageFilters');
    }

    let params = {
        params: state.filters
    };

    await $http.get('matriz-hazid', params)
        .then((response) => {
            commit('setMatrix', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 3000
            });
        });
}

/**
 * Crear matriz.
 */
export async function createMatrix({state, commit}) {

    return new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});

        commit('setCompanyIdSelectedMatrix', state.filters.company_id);

        await $http.post('matriz-hazid', state.selected_matrix)
            .then(async (response) => {
                commit('setModalShow', false);
                commit('setSelectedMatrix', response.data.data);
                commit('dashboard/load', false, {root: true});

                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien',
                    text: response.data.message,
                    showConfirmButton: true,
                    timer: 3000
                });

                resolve(response.data.data);
            }).catch(async (error) => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 3000
                });

                reject();
            });
    });
}

/**
 * Obtener matriz.
 */
export async function getSelectedMatrix({state, commit}, {id, company_id}) {
    commit('dashboard/load', true, {root: true});

    await $http.get(`matriz-hazid/${id}/${company_id}`)
        .then((response) => {
            commit('setSelectedMatrix', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 3000
            });
        });
}

/**
 * Descargar matriz.
 */
export async function downloadExcelMatrix({state, commit}, {id, company_id}) {
    commit('dashboard/load', true, {root: true});

    let name = 'MATRIZ_HAZID_' + state.selected_matrix.company.nombre + '.xlsx';

    await $http({
        url: `matriz-hazid/excel/${id}/${company_id}`,
        method: 'GET',
        responseType: 'blob'
    }).then((response) => {
        window.downloadFile(response.data,name)
        commit('dashboard/load', false, {root: true});
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error con la descarga del reporte',
            showConfirmButton: true,
            timer: 5000
        });
    });
}

/**
 * Eliminar matriz.
 */
export async function deleteMatrix({commit, state, dispatch}, selected_matrix) {
    await Swal.fire({
        title: 'Eliminar',
        text: '¿Está seguro de eliminar la matriz HAZID seleccionada?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si'
    }).then(async (result) => {
        if (result.value) {
            commit('dashboard/load', true, {root: true});

            await $http.delete(`matriz-hazid/${selected_matrix.id}/${selected_matrix.slq_company_id}`)
                .then(async (response) => {
                    commit('dashboard/load', false, {root: true});
                    await dispatch('getMatrix', true);

                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000
                    });
                })
                .catch(async (error) => {
                    commit('dashboard/load', false, {root: true});

                    await Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 3000
                    });
                });
        }
    });
}

/**
 * Obtener empresas.
 */
export async function getCompanies({dispatch, commit, state}, filter) {
    dispatch('getCompaniesRequest', filter)
        .then(empresas => commit('setCompanies', empresas));
}

/**
 * Obtener empresas filtro.
 */
export async function getCompaniesFilter({commit, dispatch}, filter) {
    dispatch('getCompaniesRequest', filter)
        .then(empresas => commit('setCompaniesFilter', empresas));
}

/**
 * Obtener empresas petición.
 */
export async function getCompaniesRequest({commit, state, rootState}, filter) {

    return await new Promise(async (resolve, reject) => {
        if (!rootState.dashboard.loader && filter && filter.length > 1) {

            commit('dashboard/load', true, {root: true});

            let params = {
                params: {
                    nombre: filter
                }
            };

            await $http.get('/empresas/lista', params)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                })
                .catch(() => {
                    commit('dashboard/load', false, {root: true});
                    console.warn('No se encontraron empresas con el nombre especificado');
                    reject([]);
                });
        }
    });
}

/**
 * Obtener ubicaciones.
 */
export async function getLocations({dispatch, commit, state}, company_id) {
    await dispatch('getLocationsRequest', company_id).then((data) => {
        commit('setLocations', data);
    }).catch((e) => console.error(e));
}

/**
 * Obtener ubicaciones filtro.
 */
export async function getLocationsFilter({dispatch, commit, state}, company_id) {
    await dispatch('getLocationsRequest', company_id).then((data) => {
        commit('setLocationsFilter', data);
    }).catch((e) => console.error(e));
}

/**
 * Obtener ubicaciones petición.
 */
export async function getLocationsRequest({dispatch, commit, state}, company_id) {
    if (company_id) {
        return await new Promise(async (resolve, reject) => {
            commit('dashboard/load', true, {root: true});
            await $http.get(`company/location/tree/${company_id}`)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                }).catch(() => {
                    commit('dashboard/load', false, {root: true});
                    reject();
                });
        });
    }
}

/**
 * Obtener procesos.
 */
export async function getProcesses({dispatch, commit, state}, company_id) {
    if (company_id) {
        commit('dashboard/load', true, {root: true});

        await $http.get(`procesos`, {params: {company_id}})
            .then((response) => {
                commit('setProcesses', response.data.data);
                commit('dashboard/load', false, {root: true});
            }).catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener actividades.
 */
export async function getActivities({dispatch, commit, state}, company_id) {
    if (company_id && Number.isInteger(state.process.id)) {
        commit('dashboard/load', true, {root: true});

        await $http.get(`actividades`, {params: {company_id, process_id: state.process.id}})
            .then((response) => {
                commit('setActivities', response.data.data);
                commit('dashboard/load', false, {root: true});
            }).catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    } else {
        commit('setActivities', []);
    }
}


/**
 * Obtener categorías SGA.
 */
export async function getCategories({dispatch, commit, state}, company_id) {
    if (company_id) {
        commit('dashboard/load', true, {root: true});

        await $http.get(`categorias-sga`, {params: {company_id}})
            .then((response) => {
                commit('setCategories', response.data.data);
                commit('dashboard/load', false, {root: true});
            }).catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener top events.
 */
export async function getTopEvents({dispatch, commit, state}) {
    commit('dashboard/load', true, {root: true});

    await $http.get(`/lists/TEIP1`)
        .then((response) => {
            commit('setTopEvents', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener las fuentes de peligro.
 */
export async function getDangerSources({dispatch, commit, state}) {
    commit('dashboard/load', true, {root: true});

    await $http.get(`/lists/FPEL`)
        .then((response) => {
            commit('setDangerSources', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener las barreras.
 */
export async function getBarriers({dispatch, commit, state}) {
    commit('dashboard/load', true, {root: true});

    await $http.get(`/lists/BAR1`)
        .then((response) => {
            commit('setBarriers', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear proceso.
 */
export async function createProcess({dispatch, commit, state}) {
    commit('dashboard/load', true, {root: true});

    commit('setTopEventsCategoriesActivitiesObjectsProcess');

    await $http.post(`procesos/matriz-hazid/${state.selected_matrix.id}/${state.selected_matrix.slq_company_id}`, state.process)
        .then(async (response) => {
            await dispatch('getSelectedMatrix', {
                id: state.selected_matrix.id,
                company_id: state.selected_matrix.slq_company_id
            });

            await dispatch('getProcesses', state.selected_matrix.slq_company_id);

            commit('dashboard/load', false, {root: true});

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 3000
            });
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Eliminar proceso.
 */
export async function deleteProcess({commit, state, dispatch}, process) {
    await Swal.fire({
        title: 'Eliminar',
        text: '¿Está seguro de eliminar el proceso seleccionado?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si'
    }).then(async (result) => {
        if (result.value) {
            commit('dashboard/load', true, {root: true});

            await $http.delete(`procesos/matriz-hazid/${process.id}/${state.selected_matrix.slq_company_id}`)
                .then(async (response) => {
                    commit('dashboard/load', false, {root: true});
                    await dispatch('getSelectedMatrix', {
                        id: state.selected_matrix.id,
                        company_id: state.selected_matrix.slq_company_id
                    });

                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000
                    });
                })
                .catch(async (error) => {
                    commit('dashboard/load', false, {root: true});

                    await Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 3000
                    });
                });
        }
    });
}

export async function saveEvaluation({commit, state, dispatch}, top_event) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`/top-events/consecuencias/${top_event.id}/${state.selected_matrix.slq_company_id}`, top_event)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});

            await dispatch('getSelectedMatrix', {
                id: state.selected_matrix.id,
                company_id: state.selected_matrix.slq_company_id
            });

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 3000
            });
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

export async function updateEvaluation({commit, state, dispatch}) {
    commit('dashboard/load', true, {root: true});

    let top_event = state.top_event;

    await $http.put(`/top-events/consecuencias/${top_event.id}/${state.selected_matrix.slq_company_id}`, top_event)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});

            await dispatch('getSelectedMatrix', {
                id: state.selected_matrix.id,
                company_id: state.selected_matrix.slq_company_id
            });

            await dispatch('getBarriers');

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 3000
            });
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

